import React, { useState } from "react";
import PropTypes from "prop-types";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Box, Button, Modal, Typography } from "@mui/material";
import { updateReviewAndSign, updateSaveForLater, setEditPreviewApplicant } from "../../new-booking-form.slice";
import { route } from "../../../../services/apiRoutes";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import SnackbarAlert from "../../../../shared-components/snackbar-alert/SnackbarAlert";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";
import { getErrorMessage, getLastStep } from "../../../../utilis/common-funtions";

const TAConditionCTA = ({ handlePrevious }) => {
  const { applicantData, activeStep, isLoading } = useSelector(
    (state) => state?.newBookingForm
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { oppId } = useParams();
  const [openModal, setOpenModal] = useState(false);


  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [acceptTermsAndCondition, setAcceptTermsAndCondition] = useState(
    applicantData?.isAgreedOnTerms || false
  );

  const handleSubmit = (type) => {
    let payload = {
      isAgreedOnTerms: Boolean(acceptTermsAndCondition),
      lastStep: getLastStep(applicantData?.lastStep, activeStep),
      opportunityId: oppId,
    };
    dispatch(
      updateReviewAndSign({
        path: `${route.UPDATE_AGREED_TERMS}`,
        payload: payload,
        opportunityId: oppId,
      })
    )
      .unwrap()
      .then((res) => {
        dispatch(setEditPreviewApplicant(false));
        if (res?.status === 200) {

          history.push(`/customer-preview/${oppId}`);
        }
      })
      .catch((error) => {
        setSnackbarConfig({
          open: true,
          message: getErrorMessage(error),
          severity: "error",
        });
      });
  };

  const handleSaveForLater = (type) => {
    let payload = {
      lastStep: getLastStep(applicantData?.lastStep, activeStep),
      saveForLater: type === "saveForLater",
      isAgreedOnTerms: Boolean(acceptTermsAndCondition) ,
      opportunityId: oppId,
    };
    dispatch(
      updateSaveForLater({
        path: `${route.UPDATE_AGREED_TERMS}`,
        payload: payload,
        opportunityId: oppId,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          setOpenModal(!openModal);
        }
      })
      .catch((error) => {
        setSnackbarConfig({
          open: true,
          message: getErrorMessage(error),
          severity: "error",
        });
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div className="dashedBorder"></div>
      <label className="checkTerms">
        {t("termsAndConditions.checkboxText")}
        <input
          type="checkbox"
          checked={acceptTermsAndCondition}
          onChange={(e) => {
            setAcceptTermsAndCondition(e?.target?.checked);
          }}
        />
        <span className="checkmark"></span>
      </label>

      <div className="termsButton">
        <button
          type="button"
          className={`saveLater ${acceptTermsAndCondition ? '' : 'disabled'} resetButton`}
          onClick={() => {
            if (acceptTermsAndCondition) {
              handleSaveForLater("saveForLater");
            }
          }}
          style={{
            pointerEvents: acceptTermsAndCondition ? 'auto' : 'none',
            opacity: acceptTermsAndCondition ? 1 : 0.5,
            cursor: acceptTermsAndCondition ? 'pointer' : 'not-allowed',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z"
              stroke="#1A407D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {t("button.saveAsDraft")}

        </button>
        <div className="buttonTermsPrev">
          <button
            type="button"
            className="saveLater resetButton"
            onClick={() => {
              handlePrevious();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M15 6L9 12L15 18"
                stroke="#1A407D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {t("button.previous")}

          </button>
          <Button
            className={`saveLater btnReview ${acceptTermsAndCondition ? "" : "disableCTA"
              }`}
            onClick={handleSubmit}
            disabled={!acceptTermsAndCondition}
          >
            {t("button.reviewAndSign")}

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M15 6L9 12L15 18"
                stroke="#1a407d"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
        </div>
      </div>

      {openModal ? (
          <Modal
            open={openModal}
            onClose={() => {
              setOpenModal(!openModal);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="saveLaterModal"
            hideBackdrop={true}
            disableEscapeKeyDown={true}
          >
            <div className="modalContainer">
              <Box sx={{ border: "0" }}>
                <button
                  type="button"
                  className="closeModal resetButton"
                  onClick={() => setOpenModal(!openModal)}
                >
                  <HighlightOffIcon />
                </button>
                <Typography
                  className="modalTitle"
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                >
                  {t("termsAndConditions.draftSaved")}
                </Typography>
                <div className="titleDear marginTop">
                  {t("termsAndConditions.resumeLaterMsg")}
                  <br />
                </div>
                {/* <a className="linkText" href="https://www.puravankara.com/">
                  Link
                </a> */}
              </Box>
            </div>
          </Modal>
      ) : null}
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};



TAConditionCTA.propTypes = {
  handlePrevious: PropTypes.any,
};

export default TAConditionCTA;
